import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';


const initialState = []

export default function appReducer(state = initialState, action) {
  switch (action.type) {

    case types.ADD_ASSETS: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.ADD_ASSET: {
      return [
        ...state,
        action.payload
      ]
    }

    case 'UPDATE_FULL_ASSETS':
      return [
        ...state,
        ...action.payload
      ]

    case types.RESET_ASSETS:
      return [
        ...action.payload
      ]

    default:
      return state;
  }
}
